import { useEffect } from 'react';

/**
 * Custom hook to handle Osano cookie consent modal scroll locking.
 *
 * This hook sets up a MutationObserver to watch for Osano consent modals
 * and applies the `data-lenis-prevent` attribute to prevent scroll conflicts
 * with Lenis smooth scrolling library.
 */
export function useOsanoScrollLock() {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const osanoElement = document.querySelector('.osano-cm-info--open');
      if (osanoElement && !osanoElement.hasAttribute('data-lenis-prevent')) {
        osanoElement.setAttribute('data-lenis-prevent', 'true');
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    // Cleanup function to disconnect observer when component unmounts
    return () => {
      observer.disconnect();
    };
  }, []);
}
